// React Compoment
import React from 'react'

// Features
import { Routes } from '../../routes'
import { OwnerPages } from '../../features/dashboard'

// Layout
import DashLayout from '../../layouts/dashboard/dashLayout'

const OwnerView = () => {
    const pathname = window.location.pathname

    return (
        <DashLayout>
            {pathname === Routes.OWNER_LIST ?
                <OwnerPages />
                :
                <OwnerPages />
            }

        </DashLayout>
    )
}

export default OwnerView;